import React, { useEffect, useState } from "react";
import MobileLayout from "../components/layout/MobileLayout";
import { api } from "../lib/api";
import { Crown, ArrowDownCircle, ArrowUpCircle, Gift, Trophy, Wallet, Sparkles, BookOpen } from "lucide-react";

const typeMeta = {
  deposit:      { label: "DEPOSIT",  Icon: ArrowDownCircle, tint: "from-emerald-400 to-emerald-600" },
  withdraw:     { label: "WITHDRAW", Icon: ArrowUpCircle,   tint: "from-rose-500 to-rose-700" },
  bid:          { label: "BID",      Icon: Sparkles,        tint: "from-sky-400 to-indigo-600" },
  win:          { label: "WIN",      Icon: Trophy,          tint: "from-yellow-400 to-amber-500" },
  bonus:        { label: "BONUS",    Icon: Gift,            tint: "from-fuchsia-500 to-purple-700" },
  admin_adjust: { label: "ADMIN",    Icon: Wallet,          tint: "from-blue-500 to-blue-800" },
};

const statusChip = (s) => (
  s === "approved" ? "bg-emerald-500/20 text-emerald-300 border-emerald-400/40" :
  s === "pending"  ? "bg-amber-500/20 text-amber-300 border-amber-400/40" :
                     "bg-rose-500/20 text-rose-300 border-rose-400/40"
);

export default function Passbook() {
  const [txns, setTxns] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/wallet/passbook").then(({data}) => setTxns(data)).finally(()=>setLoading(false)); }, []);

  return (
    <MobileLayout>
      {/* Royal page header */}
      <div className="relative rounded-2xl bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950 border-2 border-yellow-400/50 shadow-xl p-4 mb-4 overflow-hidden">
        <div className="absolute inset-0 pattern-grid opacity-25" />
        <div className="absolute -top-6 -right-6 w-20 h-20 bg-yellow-400/20 rounded-full blur-2xl" />
        <div className="relative flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-gold-gradient text-blue-950 flex items-center justify-center shadow-lg">
            <BookOpen className="w-6 h-6" strokeWidth={2.5} />
          </div>
          <div>
            <div className="flex items-center gap-1.5">
              <Crown className="w-4 h-4 text-yellow-400" fill="currentColor" />
              <span className="font-display font-black text-xl text-gold-shine leading-none">Passbook</span>
            </div>
            <div className="text-[10px] font-black tracking-[0.2em] text-blue-200 mt-1">ALL YOUR MONEY MOVES</div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="space-y-2">{Array.from({length:5}).map((_,i)=><div key={i} className="h-20 bg-blue-900/40 rounded-2xl animate-pulse" />)}</div>
      ) : txns.length === 0 ? (
        <div className="text-center py-16 text-blue-300 text-sm border-2 border-dashed border-yellow-400/30 rounded-2xl bg-blue-950/40">
          <Crown className="w-10 h-10 text-yellow-400/50 mx-auto mb-2" />
          Koi transaction abhi nahi hai
        </div>
      ) : (
        <div className="space-y-2" data-testid="passbook-list">
          {txns.map(t => {
            const m = typeMeta[t.type] || { label: t.type.toUpperCase(), Icon: Wallet, tint: "from-slate-500 to-slate-700" };
            const { Icon } = m;
            const positive = t.amount >= 0;
            return (
              <div key={t.id} className="relative bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950 border border-yellow-400/30 rounded-2xl p-3 shadow-xl overflow-hidden" data-testid={`txn-${t.id}`}>
                <div className="absolute inset-0 pattern-grid opacity-15" />
                <div className="relative flex items-center gap-3">
                  <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${m.tint} text-white flex items-center justify-center shadow-lg shrink-0`}>
                    <Icon className="w-5 h-5" strokeWidth={2.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-[10px] uppercase tracking-widest font-black text-yellow-300">{m.label}</span>
                      <span className={`text-[9px] uppercase tracking-widest font-black px-2 py-0.5 rounded-full border ${statusChip(t.status)}`}>{t.status}</span>
                    </div>
                    <div className="text-xs text-blue-100 mt-0.5 truncate">{t.note || "—"}</div>
                    <div className="text-[10px] text-blue-300/70 mt-0.5 tabular-nums">{new Date(t.created_at).toLocaleString()}</div>
                  </div>
                  <div className={`shrink-0 tabular-nums font-display font-black text-lg drop-shadow-[0_0_6px_rgba(0,0,0,0.5)] ${positive ? "text-emerald-300" : "text-rose-300"}`}>
                    {positive ? "+" : ""}₹{Math.abs(t.amount)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </MobileLayout>
  );
}
